import React from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '@/auth/authConfig';
import '@tabler/icons-webfont/dist/tabler-icons.min.css';
import './styles/variables.css';
import './styles/global.css';
import App from './App';

async function bootstrap() {
  const msal = new PublicClientApplication(msalConfig);
  await msal.initialize();

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msal}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

void bootstrap();
